const FormHelperText = (theme) => {
  return {
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginLeft: '4px',
          marginRight: '4px',
        },
      },
    },
  };
};

export default FormHelperText;
